import type * as Types from '../../../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserQuery = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string, readonly digitalCastSettings?: Record<string, any> | null, readonly graphStats: ReadonlyArray<{ readonly __typename?: 'YalperGraphStat', readonly date: string, readonly spent: number, readonly clicks: number, readonly impressions: number, readonly extendedPlatform: Types.YalperExtendedPlatform }>, readonly mediaplanStats: ReadonlyArray<{ readonly __typename?: 'YalperMediaplanStat', readonly collectedOn: string, readonly avgVideoCompleteCost: number, readonly bounces: number, readonly comments: number, readonly impressions: number, readonly conversions: number, readonly likes: number, readonly reach: number, readonly revenue: number, readonly sessions: number, readonly shares: number, readonly spent: number, readonly videoCompleteRate: number, readonly videoComplete: number }>, readonly mediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly budget: number, readonly startOn: string, readonly endOn?: string | null, readonly repeat?: Types.AccountsMediaplanRepeat | null, readonly kpis?: ReadonlyArray<{ readonly __typename?: 'AccountsKpi', readonly name: Types.AccountsKpiName, readonly value: string | number, readonly primary: boolean }> | null }> } | null, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly planId?: number | null } } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      id
      name
      graphStats(endDate: $endDate, startDate: $startDate) {
        date
        spent
        clicks
        impressions
        extendedPlatform
      }
      mediaplanStats(endDate: $endDate, startDate: $startDate) {
        collectedOn
        avgVideoCompleteCost
        bounces
        comments
        impressions
        conversions
        likes
        reach
        revenue
        sessions
        shares
        spent
        videoCompleteRate
        videoComplete
      }
      mediaplans(endDate: $endDate, startDate: $startDate) {
        id
        budget
        startOn
        endOn
        repeat
        kpis {
          name
          value
          primary
        }
      }
      digitalCastSettings
    }
    subscription {
      planId
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;